import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'home',
        component: () =>
            import ('@/views/home.vue')
    },
    {
        path: '/ticket',
        name: 'ticket',
        component: () =>
            import ('@/views/ticket.vue')
    },
    {
        path: '/checkIn',
        name: 'checkIn',
        component: () =>
            import ('@/views/checkIn.vue')
    },
]

const router = new Router({
    routes,
    mode: 'history'
})

export default router